import {
    Component,
    forwardRef,
    HostBinding,
    input,
    ViewEncapsulation
} from '@angular/core';
import {
    AbstractControl,
    ControlContainer,
    ControlValueAccessor,
    FormGroupDirective,
    FormsModule,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ReactiveFormsModule,
    ValidationErrors,
    Validator
} from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
    selector: 'z-date-picker',
    imports: [
        InputNumberModule,
        FloatLabelModule,
        FormsModule,
        ReactiveFormsModule,
        DatePickerModule
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ZDatePickerComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: ZDatePickerComponent
        }
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    templateUrl: './z-date-picker.component.html',
    styleUrl: './z-date-picker.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class ZDatePickerComponent implements ControlValueAccessor, Validator {
    @HostBinding('class') class?: string = 'flex';
    @HostBinding('style') style?: string = 'align-self: baseline';

    labelClassStyle = input<string | undefined>('flex grow');
    // inputClassStyle = input<string | undefined>('flex grow');
    inputStyle = input<
        | {
              [klass: string]: any;
          }
        | null
        | undefined
    >(undefined);

    label = input<string | undefined>(undefined);
    autocomplete = input<string | undefined>(undefined);
    id = input<string | undefined>(undefined);

    formControlName = input<string | undefined>(undefined);

    showClear = input<boolean | undefined>(undefined);
    readonlyInput = input<boolean | undefined>(undefined);
    variant = input<'filled' | 'outlined'>('outlined');
    showTime = input<boolean>(false);
    showIcon = input<boolean>(true);
    inline = input<boolean>(false);
    floatLabelVariant = input<'in' | 'on' | 'over'>('over');
    locale = input<string | undefined>(undefined);

    /* NG_VALUE_ACCESSOR Implementation */
    // https://blog.angular-university.io/angular-custom-form-controls/
    disabled: boolean = false;
    model: any;
    onModelChange: Function = () => {};
    onModelTouched: Function = () => {};

    writeValue(obj: any): void {
        if (typeof obj === 'string') this.model = new Date(obj);
        else this.model = obj;
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }
    registerOnValidatorChange?(fn: () => void): void {
        // throw new Error('Method not implemented.');
    }
    /* /NG_VALUE_ACCESSOR Implementation */
}
